module.exports = __webpack_public_path__ + "img/12 old.1ddd2b82.png";